const ArcanaDiagram = ({ results }) => {
    if (!results) return null;

    const monthArkanaPoint = { x: 100, y: -20 }; 
    const yearArcanaPoint = { x: 300, y: 300 }; 
    const dayArcanaPoint = { x: -100, y: 300 };

    const achievement1Point = { x: -100, y: 100 };
    const achievement2Point = { x: 100, y: 420 };
    const achievement3Point = { x: 250, y: 100 };  
    const achievement4Point = { x: 300, y: 100 }; 


    const karmicKnot1Point = { x: 0, y: 150 }; 
    const karmicKnot2Point = { x: 100, y: 300 };
    const karmicKnot3Point = { x: 350, y: 150 };  
    const karmicKnot4Point = { x: 150, y: 250 };  
    const karmicKnot5Point = { x: 350, y: 250 };  

    const selfRealizationPoint = { x: 250, y: 200 };

  return (
      <svg
        viewBox="0 -50 500 500"
        preserveAspectRatio="xMidYMid meet"
        style={{ width: "100%", height: "auto", maxWidth: "600px", display: "block", margin: "0 auto" }}
      >
        <defs>
          <radialGradient id="yellowGradient" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#fef08a" />   
            <stop offset="100%" stopColor="#eab308" /> 
          </radialGradient>
          <radialGradient id="greenGradient" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#86efac" />  
            <stop offset="100%" stopColor="#16a34a" /> 
          </radialGradient>
          <radialGradient id="redGradient" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#fca5a5" />   
            <stop offset="100%" stopColor="#b91c1c" />
          </radialGradient>
        </defs>
        <polygon
          points={`${monthArkanaPoint.x + 150},${monthArkanaPoint.y} ${yearArcanaPoint.x + 150},${yearArcanaPoint.y} ${dayArcanaPoint.x + 150},${dayArcanaPoint.y}`} // Adjust X axis to center
          fill="none"
          stroke="black"
          strokeWidth="2"
        />
        <polygon
          points={`${achievement2Point.x + 150},${achievement2Point.y} ${achievement4Point.x + 150},${achievement4Point.y} ${achievement1Point.x + 150},${achievement1Point.y}`} // Adjust X axis to center
          fill="none"
          stroke="black"
          strokeWidth="2"
        />
        
        {[monthArkanaPoint, yearArcanaPoint, dayArcanaPoint, achievement2Point, achievement4Point, achievement1Point].map((p, i) => (
          <line
            key={i}
            x1={selfRealizationPoint.x}
            y1={selfRealizationPoint.y}
            x2={p.x + 150}
            y2={p.y}
            stroke="black"
            strokeWidth="1"
          />
        ))}
  
        <circle cx={selfRealizationPoint.x} cy={selfRealizationPoint.y} r="20" fill="url(#yellowGradient)" />          
        <text x={selfRealizationPoint.x} y={selfRealizationPoint.y} fontSize="clamp(12px, 2vw, 18px)" fill="black" fontWeight={700} textAnchor="middle" alignmentBaseline="middle">
          {results.selfRealization}
        </text>

  
        {/* Arcana */}
        <g key={0}>
          <circle cx={monthArkanaPoint.x + 150} cy={monthArkanaPoint.y} r="20" fill="url(#yellowGradient)" />
          <text x={monthArkanaPoint.x + 150} y={monthArkanaPoint.y} fontSize="clamp(12px, 2vw, 18px)" fill="black" fontWeight={700} textAnchor="middle" alignmentBaseline="middle">
            {results.monthArcana}
          </text>
        </g>
        <g key={1}>
          <circle cx={yearArcanaPoint.x + 150} cy={yearArcanaPoint.y} r="20" fill="url(#yellowGradient)" />
          <text x={yearArcanaPoint.x + 140} y={yearArcanaPoint.y + 5} fontSize="clamp(12px, 2vw, 18px)" fontWeight={700} fill="black">{results.yearArcana}</text>
        </g>
        <g key={2}>
          <circle cx={dayArcanaPoint.x + 150} cy={dayArcanaPoint.y} r="20" fill="url(#yellowGradient)" />
          <text x={dayArcanaPoint.x + 145} y={dayArcanaPoint.y + 5} fontSize="clamp(12px, 2vw, 18px)" fontWeight={700} fill="black">{results.dayArcana}</text>
        </g>
          
        {/* ACHIEVEMENTS */}
      
        <g key={3}>
          <circle cx={achievement1Point.x + 150} cy={achievement1Point.y} r="20" fill="url(#greenGradient)" />
          <text x={achievement1Point.x + 150} y={achievement1Point.y} fontSize="clamp(12px, 2vw, 18px)" fill="black" fontWeight={700} textAnchor="middle" alignmentBaseline="middle">{results.achievements[0]}</text>
        </g>
        <g key={4}>
          <circle cx={achievement2Point.x + 150} cy={achievement2Point.y} r="20" fill="url(#greenGradient)" />
          <text x={achievement2Point.x + 150} y={achievement2Point.y} fontSize="clamp(12px, 2vw, 18px)" fill="black" fontWeight={700} textAnchor="middle" alignmentBaseline="middle">{results.achievements[1]}</text>
        </g>
        <g key={5}>
          <circle cx={achievement3Point.x} cy={achievement3Point.y} r="20" fill="url(#greenGradient)" />
          <text x={achievement3Point.x} y={achievement3Point.y} fontSize="clamp(12px, 2vw, 18px)" fill="black" fontWeight={700} textAnchor="middle" alignmentBaseline="middle">{results.achievements[2]}</text>        
        </g>
        <g key={6}>
          <circle cx={achievement4Point.x + 150} cy={achievement4Point.y} r="20" fill="url(#greenGradient)" />
          <text x={achievement4Point.x + 150} y={achievement4Point.y} fontSize="clamp(12px, 2vw, 18px)" fontWeight={700} fill="black" textAnchor="middle" alignmentBaseline="middle">{results.achievements[3]}</text>
        </g>
        {/* KNOTS */}

        <g key={7}>
          <circle cx={karmicKnot1Point.x + 150} cy={karmicKnot1Point.y} r="20" fill="url(#redGradient)" />
          <text x={karmicKnot1Point.x + 150} y={karmicKnot1Point.y} fontSize="clamp(12px, 2vw, 18px)" fill="black" textAnchor="middle" fontWeight={700} alignmentBaseline="middle">{results.karmicKnots[0]}</text>
        </g>
        <g key={8}>
          <circle cx={karmicKnot2Point.x + 150} cy={karmicKnot2Point.y} r="20" fill="url(#redGradient)" />
          <text x={karmicKnot2Point.x + 150} y={karmicKnot2Point.y} fontSize="clamp(12px, 2vw, 18px)" fill="black" textAnchor="middle" fontWeight={700} alignmentBaseline="middle">{results.karmicKnots[1]}</text>
        </g>
        <g key={9}>
          <circle cx={karmicKnot3Point.x} cy={karmicKnot3Point.y} r="20" fill="url(#redGradient)" />
          <text x={karmicKnot3Point.x} y={karmicKnot3Point.y} fontSize="clamp(12px, 2vw, 18px)" fill="black" textAnchor="middle" fontWeight={700} alignmentBaseline="middle">{results.karmicKnots[2]}</text>        
        </g>
        <g key={10}>
          <circle cx={karmicKnot4Point.x} cy={karmicKnot4Point.y} r="20" fill="url(#redGradient)" />
          <text x={karmicKnot4Point.x} y={karmicKnot4Point.y} fontSize="clamp(12px, 2vw, 18px)" fill="black" textAnchor="middle" fontWeight={700} alignmentBaseline="middle">{results.karmicKnots[3]}</text>
        </g>
        <g key={11}>
          <circle cx={karmicKnot5Point.x} cy={karmicKnot5Point.y} r="20" fill="url(#redGradient)" />
          <text x={karmicKnot5Point.x} y={karmicKnot5Point.y} fontSize="clamp(12px, 2vw, 18px)" fill="black" textAnchor="middle" fontWeight={700} alignmentBaseline="middle">{results.karmicKnots[4]}</text>
        </g>
      </svg>
  );
};

export default ArcanaDiagram;
